<div class="not-found">
  <div class="image-wrap">
    <img src="{{ assetsUrl('/assets/images/404.svg') }}" [attr.title]="'not-found.balloon' | customLocale">
    <div class="balloon">{{ 'not-found.balloon' | customLocale }}</div>
  </div>
  <div class="title bold">{{ title | customLocale }}</div>
</div>
